import mock from '@/@fake-db/mock'
/* eslint-disable global-require */
const data = {
  pricing: {
    plans: [{
      id: 1,
      without_payment: true,
      is_popular: false,
      is_enterprise: false,
      title: 'Basic',
      img: require('@/assets/images/illustration/Pot1.svg'),
      subtitle: 'A simple start for everyone',
      monthlyPrice: 0,
      yearlyPlan: {
        perMonth: 0,
        totalAnual: 0,
      },
      planBenefits: [
        '5 Invoices Per Month',
        'Invoice Designer',
      ],
      popular: false,
    },
    {
      id: 2,
      without_payment: false,
      is_popular: true,
      is_enterprise: false,
      title: 'Standard',
      img: require('@/assets/images/illustration/Pot2.svg'),
      subtitle: 'For Small Business',
      monthlyPrice: 15,
      yearlyPlan: {
        perMonth: 12,
        totalAnual: 144,
      },
      planBenefits: [
        'Unlimited Clients',
        'Invoice Designer with multiple layout',
        '50 Invoices Per Month',
      ],
      popular: true,
    },
    {
      id: 3,
      without_payment: false,
      is_popular: false,
      is_enterprise: true,
      title: 'Premium',
      img: require('@/assets/images/illustration/Pot3.svg'),
      subtitle: 'For Business',
      monthlyPrice: 9,
      yearlyPlan: {
        perMonth: 9,
        totalAnual: 9,
      },
      planBenefits: [
        'Multiple User',
        'Multiple Branches',
        'Unlimited Invoice',
        '*ContactUs',
      ],
      popular: false,
    },
    ],
    qandA: [
      {
        question: 'Does my subscription automatically renew?',
        ans:
          'Pastry pudding cookie toffee bonbon jujubes jujubes powder topping. Jelly beans gummi bears sweet roll bonbon muffin liquorice. Wafer lollipop sesame snaps. Brownie macaroon cookie muffin cupcake candy caramels tiramisu. Oat cake chocolate cake sweet jelly-o brownie biscuit marzipan. Jujubes donut marzipan chocolate bar. Jujubes sugar plum jelly beans tiramisu icing cheesecake.',
      },
      {
        question: 'Can I store the item on an intranet so everyone has access?',
        ans:
          'Tiramisu marshmallow dessert halvah bonbon cake gingerbread. Jelly beans chocolate pie powder. Dessert pudding chocolate cake bonbon bear claw cotton candy cheesecake. Biscuit fruitcake macaroon carrot cake. Chocolate cake bear claw muffin chupa chups pudding.',
      },
      {
        question: 'Am I allowed to modify the item that I purchased?',
        ans:
          'Tart gummies dragée lollipop fruitcake pastry oat cake. Cookie jelly jelly macaroon icing jelly beans soufflé cake sweet. Macaroon sesame snaps cheesecake tart cake sugar plum. Dessert jelly-o sweet muffin chocolate candy pie tootsie roll marzipan. Carrot cake marshmallow pastry. Bonbon biscuit pastry topping toffee dessert gummies. Topping apple pie pie croissant cotton candy dessert tiramisu.',
      },
    ],
  },
}
/* eslint-disable global-require */
mock.onGet('/pricing/data').reply(() => [200, data.pricing])
